<template>
  <div v-if="result.nickname != null" class="resultUser">
    <div class="resultUser__date">{{ date[0] }}年{{ date[1] }}日{{ date[2] }}日生まれ</div>
    <div class="resultUser__name">{{ result.nickname }}さん</div>
  </div>
  <div v-else class="resultUser">
    <div class="resultUser__date">{{ date[0] }}年{{ date[1] }}日{{ date[2] }}日生まれの</div>
    <div class="resultUser__name">あなたの運勢</div>
  </div>
</template>

<script>
export default {
  name: "resultUser",
  data() {
    return {
      date: [
        this.result.birth.slice(0, 4),
        this.result.birth.slice(4, 6),
        this.result.birth.slice(6, 8),
      ]
    }
  },
  props: {
    result: {
      type: Object,
      default () {
        return {}
      }
    }
  },
}
</script>

<style scoped lang="scss">
.resultUser {
  background: #FF5E4E;
  padding: 16px 10px 20px;
  color: #FFFFFF;
  text-align: center;
  &__date {
    font-weight: bold;
    font-size: 14px;
    line-height: 14px;
    margin: 0 0 10px;
  }
  &__name {
    font-weight: bold;
    font-size: 24px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/resultUser.vue